function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 51 42"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  d: "M33.91 40.27v-4.36c0-2.32-.91-4.54-2.54-6.17a8.65 8.65 0 00-6.14-2.56H10.05c-2.3 0-4.51.92-6.14 2.56a8.75 8.75 0 00-2.54 6.17v4.36m16.27-21.81a8.7 8.7 0 008.68-8.73A8.7 8.7 0 0017.64 1a8.7 8.7 0 00-8.68 8.73 8.7 8.7 0 008.68 8.73zm18.44-.01l4.34 4.37 8.68-8.73"
})));